// Translation mappings for user interface elements

// Role translations
export const ROLE_TRANSLATIONS = {
  admin: 'Administrador',
  user: 'Usuario',
  chef: 'Chef',
  client: 'Cliente'
};

// Status translations
export const STATUS_TRANSLATIONS = {
  active: 'Activo',
  inactive: 'Inactivo',
  suspended: 'Suspendido',
  pending: 'Pendiente'
};

// Permission translations
export const PERMISSION_TRANSLATIONS = {
  canCreateRecipes: 'Puede crear recetas',
  canEditRecipes: 'Puede editar recetas',
  canDeleteRecipes: 'Puede eliminar recetas',
  canManageUsers: 'Puede gestionar usuarios',
  canManagePlans: 'Puede gestionar planes',
  canViewReports: 'Puede ver reportes'
};

// Helper functions
export const translateRole = (role) => {
  return ROLE_TRANSLATIONS[role] || role;
};

export const translateStatus = (status) => {
  return STATUS_TRANSLATIONS[status] || status;
};

export const translatePermission = (permission) => {
  return PERMISSION_TRANSLATIONS[permission] || permission;
};

// Common UI translations
export const UI_TRANSLATIONS = {
  // Actions
  save: 'Guardar',
  cancel: 'Cancelar',
  delete: 'Eliminar',
  edit: 'Editar',
  create: 'Crear',
  update: 'Actualizar',
  search: 'Buscar',
  filter: 'Filtrar',
  export: 'Exportar',
  import: 'Importar',
  
  // Common labels
  name: 'Nombre',
  email: 'Email',
  phone: 'Teléfono',
  address: 'Dirección',
  role: 'Rol',
  status: 'Estado',
  permissions: 'Permisos',
  preferences: 'Preferencias',
  
  // Time
  createdAt: 'Creado en',
  updatedAt: 'Actualizado en',
  lastLogin: 'Último acceso',
  
  // Messages
  loading: 'Cargando...',
  saving: 'Guardando...',
  saved: 'Guardado',
  error: 'Error',
  success: 'Éxito',
  warning: 'Advertencia',
  
  // Confirmations
  deleteConfirm: '¿Estás seguro de que quieres eliminar este elemento?',
  unsavedChanges: 'Tienes cambios sin guardar. ¿Quieres continuar?',
  
  // Navigation
  dashboard: 'Panel de Control',
  users: 'Usuarios',
  recipes: 'Recetas',
  mealPlans: 'Planes de Comida',
  settings: 'Configuración',
  profile: 'Perfil',
  logout: 'Cerrar Sesión'
};